import { useMutation, useQuery } from "react-query"
import DataService from "../../../config/DataServices"
import { useToast } from "../../../hook/usetoast";
import { queryClient } from "../../../config";
const { getRequest, postRequest } = DataService();

export const useProfileDetails = () => {

    return useQuery({
        queryKey: ['get-profile'],
        queryFn: () => {
            return getRequest("user/auth/profileGet")
        },
        select: res => res?.data
    })
}
export const useUserTotalWithdraw = () => {

    return useQuery({
        queryKey: ['get-balance'],
        queryFn: () => {
            return getRequest("user/auth/totalWithdraw")
        },
        select: res => res?.data
    })
}

export const useUpdateProfile = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest('user/auth/profileCreate', data)
        },
        onSuccess: success => {
            if (success?.status) {
                queryClient.refetchQueries("get-profile")
                return toast.success(success?.message)
            }
            return toast.error(success?.message)
        }
    })
}
export const useUserSendMail = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest('user/auth/send-mail', data)
        },
        onSuccess: success => {
            if (success?.status) {
                
                return toast.success(success?.message)
            }
            return toast.error(success?.message)
        }
    })
}


export const useUserVerifyMail = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest('user/auth/verify-mail', data)
        },
        onSuccess: success => {
            if (success?.status) {
                queryClient.refetchQueries("get-profile")
                return toast.success(success?.message)
            }
        }
    })
}